import { ClientID } from '../types/banner/clients/clients';

const CLIENT_LABELS: Record<ClientID, string> = {
  TEST: 'Test',
  DISNEY: 'Disney',
  RESUMIDO: 'Resumido',
  GPOVALLAS: 'Grupo Vallas',
  MACRO: 'Banco Macro',
  LUZU: 'Luzu',
  GVAZ: 'Grupo Vázquez',
  HIPOTECARIO: 'Banco Hipotecario'
};

export const getClientOptions = (excludeTest: boolean = true) => {
  const clients = Object.keys(CLIENT_LABELS) as ClientID[];

  return clients
    .filter(client => !excludeTest || client !== 'TEST')
    .map(client => ({
      value: client,
      label: CLIENT_LABELS[client]
    }));
};

export const getClientLabel = (clientId: ClientID): string => {
  return CLIENT_LABELS[clientId] || clientId;
};
